import { create } from 'zustand';

export type HomeIntroPhase = 'idle' | 'active' | 'settling' | 'complete';
export type HomePopupPhase = 'hidden' | 'revealing' | 'visible' | 'dismissed';

interface HomeUiState {
  headerHidden: boolean;
  introPhase: HomeIntroPhase;
  popupEligible: boolean;
  popupPhase: HomePopupPhase;
  dismissPopup: () => void;
  finishPopupReveal: () => void;
  hidePopupUntilNextEligibilityCheck: () => void;
  resetHomeUi: () => void;
  setHeaderHidden: (headerHidden: boolean) => void;
  setIntroPhase: (introPhase: HomeIntroPhase) => void;
  setPopupEligible: (popupEligible: boolean) => void;
  startPopupReveal: () => void;
}

const initialState = {
  headerHidden: false,
  introPhase: 'idle' as const,
  popupEligible: false,
  popupPhase: 'hidden' as const,
};

export const useHomeUiStore = create<HomeUiState>((set) => ({
  ...initialState,
  dismissPopup: () => {
    set({
      popupEligible: false,
      popupPhase: 'dismissed',
    });
  },
  finishPopupReveal: () => {
    set((state) => ({
      popupPhase: state.popupEligible ? 'visible' : 'hidden',
    }));
  },
  hidePopupUntilNextEligibilityCheck: () => {
    set({
      popupEligible: false,
      popupPhase: 'hidden',
    });
  },
  resetHomeUi: () => {
    set((state) => ({
      ...initialState,
      popupEligible: state.popupEligible,
      popupPhase: state.popupPhase === 'dismissed' ? 'dismissed' : 'hidden',
    }));
  },
  setHeaderHidden: (headerHidden) => {
    set({ headerHidden });
  },
  setIntroPhase: (introPhase) => {
    set({ introPhase });
  },
  setPopupEligible: (popupEligible) => {
    set((state) => ({
      popupEligible,
      popupPhase:
        state.popupPhase === 'dismissed'
          ? 'dismissed'
          : popupEligible
            ? state.popupPhase
            : 'hidden',
    }));
  },
  startPopupReveal: () => {
    set((state) => {
      if (!state.popupEligible || state.popupPhase !== 'hidden') {
        return state;
      }

      return {
        popupPhase: 'revealing',
      };
    });
  },
}));
